const KNOWN_API_ERROR_CODE =
  /\b(ADVISOR_PRODUCT_SELLER_DUPLICATE|PRODUCT_RANGE_DUPLICATE|DISCOUNT_CODE_DUPLICATE|CONFLICT|UNAUTHORIZED|NOT_FOUND|FORBIDDEN|SERVER_ERROR)\b/;

/**
 * Maps a GraphQL / network error to a translated API message from errors.json (API.*).
 */
export function resolveApiErrorMessage(error, apiErrors, options = {}) {
  const { duplicateKeyMessageKey = "CONFLICT" } = options;

  const gqlErr = error?.graphQLErrors?.[0];
  const candidates = [
    gqlErr?.message,
    gqlErr?.extensions?.exception?.message,
    error?.message,
  ].filter(Boolean);

  for (const raw of candidates) {
    const s = String(raw).trim();
    if (apiErrors[s]) {
      return apiErrors[s];
    }
    const stripped = s
      .replace(/^GraphQL\s+error:\s*/i, "")
      .replace(/^Error:\s*/i, "")
      .trim();
    if (apiErrors[stripped]) {
      return apiErrors[stripped];
    }
    const match = s.match(KNOWN_API_ERROR_CODE);
    if (match && apiErrors[match[1]]) {
      return apiErrors[match[1]];
    }
    if (/duplicate key/i.test(s) || /duplicate entry/i.test(s)) {
      const dupMsg = apiErrors[duplicateKeyMessageKey];
      if (dupMsg) {
        return dupMsg;
      }
    }
  }

  return apiErrors.GENERIC;
}
